import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Segment,
  Form,
  FormGroup,
  FormField,
  Button
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardApplyPolicyPackageUX = (props: any) => {
    return(
      <div
        id="CardApplyPolicyPackageUX-div-0"
        style={{ width : "100%", height: "100%" }}>
        <Segment
          className="segment-no-shadow"
          id="CardApplyPolicyPackageUX-Segment-1">
          <div
            id="CardApplyPolicyPackageUX-div-2"
            style={{display: "flex", justifyContent: "space-between"}}>

            <div
              id="CardApplyPolicyPackageUX-div-3"
              style={{fontWeight: "bold", fontSize: "1.2rem"}}>
              {props.languageUX === "en" ? "Package Usage log" : "บันทึกใช้แพ็กเกจ"}
            </div>
            <div
              id="CardApplyPolicyPackageUX-div-12"
              style={{cursor: "pointer"}}>

            </div>
          </div>
          <hr
            id="CardApplyPolicyPackageUX-hr-6">
          </hr>
          <Form
            id="CardApplyPolicyPackageUX-Form-13">
            <FormGroup
              id="CardApplyPolicyPackageUX-FormGroup-14"
              inline={true}
              style={{paddingTop: "0.5rem"}}>
              <FormField
                id="CardApplyPolicyPackageUX-FormField-15"
                style={{flex:1}}>
              </FormField>
              <FormField
                id="CardApplyPolicyPackageUX-FormField-16"
                style={{padding:0}}>
                <Button
                  color="blue"
                  disabled={props.disabledAdd || false}
                  id="CardApplyPolicyPackageUX-Button-17"
                  onClick={props.onClickAdd}>
                  {props.languageUX === "en" ? "Add item" : "เพิ่มรายการ"}
                </Button>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardApplyPolicyPackageUX-FormGroup-18">
              <FormField
                id="CardApplyPolicyPackageUX-FormField-22"
                width={16}>
                <Table
                  data={props.applyPolicyList||[]}
                  headers={props.languageUX === "en" ? "No,Package Name, Encounter," : "ลำดับที่,ชื่อแพ็กเกจ, หมายเลขรับบริการ,"}
                  id="CardApplyPolicyPackageUX-Table-23"
                  keys="seq,name,encounters,action"
                  minRows={13}
                  showPagination={false}
                  style={{height:"calc(100dvh - 19rem)"}}
                  widths="80,^200,^120,100">
                </Table>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardApplyPolicyPackageUX-FormGroup-19">
              <FormField
                id="CardApplyPolicyPackageUX-FormField-20"
                style={{flex:1}}>
              </FormField>
              <FormField
                id="CardApplyPolicyPackageUX-FormField-21">
                <div
                  id="CardApplyPolicyPackageUX-div-24">
                  {props.ButtonConfirm}
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </Segment>
      </div>
    )
}


export default CardApplyPolicyPackageUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","language":"TH","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Thu Sep 11 2025 15:18:06 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardApplyPolicyPackageUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ width : \"100%\", height: \"100%\" }"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Segment",
      "parent": 0,
      "props": {
        "className": {
          "type": "value",
          "value": "segment-no-shadow"
        },
        "id": {
          "type": "value",
          "value": "CardApplyPolicyPackageUX-Segment-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardApplyPolicyPackageUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึกใช้แพ็กเกจ",
          "valueEN": "Package Usage log"
        },
        "id": {
          "type": "value",
          "value": "CardApplyPolicyPackageUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.2rem\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "hr",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardApplyPolicyPackageUX-hr-6"
        }
      },
      "seq": 6,
      "void": true
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardApplyPolicyPackageUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{cursor: \"pointer\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "Form",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardApplyPolicyPackageUX-Form-13"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormGroup",
      "parent": 13,
      "props": {
        "id": {
          "type": "value",
          "value": "CardApplyPolicyPackageUX-FormGroup-14"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"0.5rem\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "FormField",
      "parent": 14,
      "props": {
        "id": {
          "type": "value",
          "value": "CardApplyPolicyPackageUX-FormField-15"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "FormField",
      "parent": 14,
      "props": {
        "id": {
          "type": "value",
          "value": "CardApplyPolicyPackageUX-FormField-16"
        },
        "style": {
          "type": "code",
          "value": "{padding:0}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "Button",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มรายการ",
          "valueEN": "Add item"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledAdd || false"
        },
        "id": {
          "type": "value",
          "value": "CardApplyPolicyPackageUX-Button-17"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickAdd"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "FormGroup",
      "parent": 13,
      "props": {
        "id": {
          "type": "value",
          "value": "CardApplyPolicyPackageUX-FormGroup-18"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "FormGroup",
      "parent": 13,
      "props": {
        "id": {
          "type": "value",
          "value": "CardApplyPolicyPackageUX-FormGroup-19"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardApplyPolicyPackageUX-FormField-20"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardApplyPolicyPackageUX-FormField-21"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "FormField",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "CardApplyPolicyPackageUX-FormField-22"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 23,
      "name": "Table",
      "parent": 22,
      "props": {
        "data": {
          "type": "code",
          "value": "props.applyPolicyList||[]"
        },
        "headers": {
          "type": "value",
          "value": "ลำดับที่,ชื่อแพ็กเกจ, หมายเลขรับบริการ,",
          "valueEN": "No,Package Name, Encounter,"
        },
        "id": {
          "type": "value",
          "value": "CardApplyPolicyPackageUX-Table-23"
        },
        "keys": {
          "type": "value",
          "value": "seq,name,encounters,action"
        },
        "minRows": {
          "type": "code",
          "value": "13"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height:\"calc(100dvh - 19rem)\"}"
        },
        "widths": {
          "type": "value",
          "value": "80,^200,^120,100"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonConfirm"
        },
        "id": {
          "type": "value",
          "value": "CardApplyPolicyPackageUX-div-24"
        }
      },
      "seq": 24,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardApplyPolicyPackageUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "language": "TH",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 75
}

*********************************************************************************** */
